import styles from './Title.module.scss';
import React from 'react';
import { getTranslation } from '../../../../utils/translation';

export default function Title() {
    return (
        <h1 className={styles.title}>
            {getTranslation('login.message.welcomeTo')}
            <span className={styles.subtitle}>{getTranslation('login.message.userPanel')}</span>
        </h1>
    );
}
